import { IDict } from "./interfaces";

export const languages: string[] = ["en", "pl"];

export const DICT: IDict = {
  en: {
    navbarAbout: "About",
    navbarSkills: "Skills",
    navbarExperience: "Experience",
    navbarContact: "Contact",

    introHello: "Hello, my name is",
    introHelloMobile: "Hello, my name is",
    introName: "Damian Wilczyński",
    introFirstName: "Damian ",
    introSurName: " Wilczyński",
    introDescTopOne: "",
    introDescTopTwo: "SENIOR FULL STACK DEVELOPER",
    introDescTopTree: "based in Gdynia, Poland.",
    introDescAdd:
      "I specialize in delivering scalable web applications using Next.js, Node.js, and TypeScript. My competitive edge lies in efficiency - by leveraging advanced AI development tools (Lovable, Antigravity, Copilot), I significantly accelerate the development cycle while maintaining high code quality and architectural security.",
    introBtn: "My experience",

    aboutAttributeOne: "Commercial experience as a Full Stack Developer",
    aboutAttributeTwo:
      "Very good knowledge of Next.js, React, JavaScript, TypeScript and Node.js",
    aboutAttributeThree:
      "Experience working with advanced AI development tools",
    aboutAttributeFour:
      "Practical ability to apply the principles of DRY, SOLID and KISS",
    aboutAttributeFive: "Experience working with Agile (Kanban and Scrum)",
    aboutAttributeSix: "Knowledge of English at C1 level",
    aboutAttributeSeven:
      "Master of Science in Gdańsk University of Technology.",

    skills_html: "HTML5",
    skills_css: "CSS3",
    skills_js: "JavaScript",
    skills_react: "React",
    skills_next: "Next.js",
    skills_node: "Node.js",
    skills_express: "Express.js",
    skills_tanStack: "TanStack",
    skills_redux: "Redux",
    skills_git: "GIT Version Control",
    skills_cypress: "Cypress",
    skills_ts: "TypeScript",
    skills_mui: "Material UI",
    skills_blockchain: "Blockchain",
    skills_solidity: "Solidity",
    skills_java: "Java",

    experiencePositionEndava: "FULL STACK DEVELOPER",
    experienceDutiesEndava: [
      "I design and implement scalable Full Stack solutions within the Next.js ecosystem, with a strong focus on high performance. By leveraging advanced AI-driven tools to optimize the development and prototyping cycle, I consistently maintain clean architecture and engineering excellence.",
    ],
    experienceDatesEndava: "01/2024 - present",

    experiencePositionNest: "FRONT-END DEVELOPER",
    experienceDutiesNest: [
      "Focused on building secure, high-performance user interfaces for electronic banking systems.",
    ],
    experienceDatesNest: "11/2022 - 12/2023",

    experiencePositionAic: "FRONT-END DEVELOPER",
    experienceDutiesAic: [
      "Bridged modern frontend with Web3 technologies, leading the integration of web applications with on-chain smart contracts using Ethers.js and Web3.js.",
    ],
    experienceDatesAic: "07/2021 - 10/2022",

    experiencePositionStudioWww: "FRONT-END DEVELOPER",
    experienceDutiesStudioWww: [
      "As a developer, I have delivered end-to-end projects from concept to deployment, working on both web solutions and native mobile applications.",
    ],
    experienceDatesStudioWww: "06/2019 - 06/2021",

    experiencePositionTeldust: "PROJECT MANAGER / CONSTRUCTOR",
    experienceDutiesTeldust: [
      "Designed industrial machinery and equipment. Prepared 3D sales drawings and 2D technical documentation.",
    ],
    experienceDatesTeldust: "04/2008 - 05/2019",

    contactFormTitle: "Write to me!",
    contactFormUserNameInputPlaceholder: "Name",
    contactFormUserEmailInputPlaceholder: "Email address",
    contactFormUserMessageInputPlaceholder: "Message",
    contactFormSendBtn: "Send",
    contactSentMessageFromPage: "Your Message has been sent!",
    contactNameInvalid: "Please enter the correct details",
    contactEmailInvalid: "Email is invalid",
    contactMessageInvalid: "Your message must contain at least 5 characters",

    greetingsStart: "Have a nice ",
    greetingsDay: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    greetingsEnd: "!",
  },

  pl: {
    navbarAbout: "O mnie",
    navbarSkills: "Umiejętności",
    navbarExperience: "Doświadczenie",
    navbarContact: "Kontakt",

    introHello: "Hej, nazywam się",
    introHelloMobile: "Hej, mam na imię",
    introName: "Damian Wilczyński",
    introFirstName: "Damian ",
    introSurName: "Wilczyński",
    introDescTopOne: "",
    introDescTopTwo: "SENIOR FULL STACK DEVELOPER",
    introDescTopTree: "z Gdyni.",

    introDescAdd:
      "Specjalizuję się w dostarczaniu skalowalnych aplikacji webowych przy użyciu Next.js, Node.js i TypeScript. Moim wyróżnikiem jest efektywność - dzięki zaawansowanemu wykorzystaniu narzędzi AI (Lovable, Antigravity, Copilot) skracam cykl developmentu, nie tracąc przy tym na jakości kodu i bezpieczeństwie architektury.",
    introBtn: "Moje doświadczenie",

    aboutAttributeOne:
      "Komercyjne doświadczenie na stanowisku Full Stack Developera",
    aboutAttributeTwo:
      "Bardzo dobra znajomość Next.js, React, JavaScript, TypeScript i Node.js",
    aboutAttributeThree:
      "Doświadczenie w pracy z zaawansowanymi narzędziami AI",
    aboutAttributeFour:
      "Praktyczna umiejętność stosowania zasad DRY, SOLID i KISS",
    aboutAttributeFive: "Doświadczenie w pracy z Agile (Kanban i Scrum)",
    aboutAttributeSix: "Znajomość języka angielskiego na poziomie C1",
    aboutAttributeSeven: "Absolwent Politechniki Gdańskiej z tytułem mgr inż.",

    skills_html: "HTML5",
    skills_css: "CSS3",
    skills_js: "JavaScript",
    skills_react: "React",
    skills_next: "Next.js",
    skills_node: "Node.js",
    skills_express: "Express.js",
    skills_tanStack: "TanStack",
    skills_redux: "Redux",
    skills_git: "GIT Version Control",
    skills_cypress: "Cypress",
    skills_ts: "TypeScript",
    skills_mui: "Material UI",
    skills_blockchain: "Blockchain",
    skills_solidity: "Solidity",
    skills_java: "Java",

    experiencePositionEndava: "FULL STACK DEVELOPER",
    experienceDutiesEndava: [
      "Projektuję i wdrażam skalowalne rozwiązania Full Stack w ekosystemie Next.js, kładąc szczególny nacisk na wydajność. Wykorzystuję zaawansowane narzędzia AI do optymalizacji cyklu developmentu i prototypowania, zachowując przy tym czystą architekturę.",
    ],
    experienceDatesEndava: "01/2024 - obecnie",

    experiencePositionNest: "FRONT-END DEVELOPER",
    experienceDutiesNest: [
      "Koncentrowałem się na budowie bezpiecznych i wysoce wydajnych interfejsów użytkownika dla systemów bankowości elektronicznej.",
    ],
    experienceDatesNest: "11/2022 - 12/2023",

    experiencePositionAic: "FRONT-END DEVELOPER",
    experienceDutiesAic: [
      "Łączyłem nowoczesny frontend z technologiami Web3, odpowiadając za integrację aplikacji z inteligentnymi kontraktami na blockchainie przy użyciu bibliotek Ethers.js i Web3.js.",
    ],
    experienceDatesAic: "07/2021 - 10/2022",

    experiencePositionStudioWww: "FRONT-END DEVELOPER",
    experienceDutiesStudioWww: [
      "Jako programista kompleksowo realizowałem projekty od fazy koncepcyjnej po wdrożenie, pracując zarówno nad rozwiązaniami webowymi, jak i natywnymi aplikacjami mobilnymi.",
    ],
    experienceDatesStudioWww: "06/2019 - 06/2021",

    experiencePositionTeldust: "KIEROWNIK PROJEKTU/ KONSTRUKTOR",
    experienceDutiesTeldust: [
      "Zajmowałem się projektowaniem maszyn i urządzeń przemysłowych. Przygotowywałem rysunki ofertowe 3D oraz dokumentację techniczną 2D.",
    ],
    experienceDatesTeldust: "04/2008 - 05/2019",

    contactFormTitle: "Napisz do mnie!",
    contactFormUserNameInputPlaceholder: "Imię",
    contactFormUserEmailInputPlaceholder: "Adres email",
    contactFormUserMessageInputPlaceholder: "Treść wiadomości",
    contactFormSendBtn: "Wyślij",
    contactSentMessageFromPage: "Twoja wiadomość została wysłana!",
    contactNameInvalid: "Podaj prawidłowe dane",
    contactEmailInvalid: "Adres email jest nieprawidłowy",
    contactMessageInvalid:
      "Twoja wiadomość musi zawierać przynajmniej 5 znaków",

    greetingsStart: "Miłe",
    greetingsDay: [
      "j Niedzieli",
      "go Poniedziałku",
      "go Wtorku",
      "j Środy",
      "go Czwartku",
      "go Piatku",
      "j Soboty",
    ],
    greetingsEnd: "!",
  },
};
